/** Columns: GitHub username (required), work email (required, unique), name (optional). */
export const GITHUB_EMAIL_MAPPING_TEMPLATE_KEY = 'github-email-mapping-v1';
